module.exports = __webpack_public_path__ + "static/media/login.422d7535.svg";